import React, { useContext, useReducer, useLayoutEffect } from "react";
import { useUserContext } from "src/contexts/userContext";
import { reducer } from "src/reducers/product/productReducer";
import * as API from "src/api/request";

import _ from "lodash";
import moment from "moment";

const context = React.createContext();

const _state = {
  id: 0,
  worker_id: 0,
  modal: false,
  modal_out: false,
  rightdrawer: false,
  loading: false,
  loading2: false,
  list_department: [],
  department: null,
  organization: null,
  refresh: 0,
  date: moment(),

  isemc: 1,

  list_employee: null,
  list_workers: [],
  list_workers_out: [],
  list_plan_out: [],
  list_out: [],
  tn: null,
  list_norm: null,
  workertn: null,

  product_out: null,
  productworker: [],
  productworkerfilter: [],
  listdepartmentplan: [],
  product_sum: null,

  modaldepartment: null,
  modalcompany: null,
  modalplancount: 0,
  modalselected_department: [],

  modalcheck: null,

  factvalue: 0,

  product_ids: [],

  list_control: [],
  controlcount: null,
  controldepartment: null,
  controlrefresh: 0,

  norm: {
    modal: false,
    list: [],
    plan: [],
    checkNoNorm: "",
    list_product: [],
    refresh: 0,
  },

  list_Position: [],
  checked_positionList: [],
  selectedpositionname: null,
};

export const useProductContext = () => {
  const ctx = useContext(context);
  if (ctx === undefined) {
    throw new Error("Context must be used within a Provider");
  }
  return ctx;
};

const Context = ({ children }) => {
  const { user, checkGroup } = useUserContext();
  const [state, dispatch] = useReducer(reducer, _state);

  useLayoutEffect(() => {
    user.is_emc &&
      API.getUserDepartment().then((res) => {
        var result = [];

        if (!checkGroup([179, 374, 182]))
          result.push({
            departmentname: "Бүгд",
            departmentcode: 0,
            title: "Бүгд",
            departmentlevelid: 3,
            key: 0,
            value: 0,
            id: 0,
            pId: null,
            selectable: true,
          });

        _.map(
          _.orderBy(res, ["departmentlevelid", "departmentcode"]),
          (item) => {
            result.push({
              ...item,
              title: item.departmentcode + " | " + item.departmentname,
              key: item.id,
              value: item.departmentcode,
              id: item.id,
              pId: item.parentid,
              selectable: item.departmentlevelid !== -1,
            });
          }
        );
        result = _.filter(
          result,
          (a) => a.departmentlevelid > 1 && a.departmentlevelid < 5
        );
        dispatch({
          type: "STATE",
          data: {
            list_department: result,
          },
        });
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <context.Provider value={{ state: state, dispatch: dispatch }}>
      {children}
    </context.Provider>
  );
};
export default React.memo(Context);
